module.exports = __webpack_public_path__ + "img/11_bg.140d5b4b.jpg";